import { useEffect, useState } from 'react';
import { useInfoDrawer, InfoDrawerContent } from 'context/InfoDrawerContext';
import { Button } from 'components/Button';
import { Tooltip } from 'components/Tooltip';

interface InfoButtonProps {
  content?: InfoDrawerContent;
  tooltipText?: string;
  className?: string;
  showText?: boolean;
  variant?: 'text' | 'plain';
}

export function InfoButton({
  content = undefined,
  tooltipText = 'View information',
  showText = false,
}: InfoButtonProps) {
  const { openDrawer, drawerContent } = useInfoDrawer();
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    setShouldShow(Boolean(content ?? drawerContent));
  }, [content, drawerContent]);

  if (!shouldShow) {
    return null;
  }

  const handleClick = () => {
    if (content) {
      openDrawer(content);
    } else if (drawerContent) {
      openDrawer(drawerContent);
    }
  };

  return (
    <Tooltip tooltipContent={tooltipText}>
      <Button
        onClick={handleClick}
        iconLeft={showText ? 'InformationOutlined' : undefined}
        icon={!showText ? 'InformationOutlined' : undefined}
        priority="ghost"
        size="lg"
      >
        {showText && 'Info'}
      </Button>
    </Tooltip>
  );
}
